import { Menu } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors, fonts } from '~/layout';

export const BoxSelector = lib.styled.div`
  display: flex;
  width: 108px;
  height: 26px;
  align-items: center;
  justify-content: ${props => (props.loading ? 'center' : 'space-between')};

  span {
    text-transform: none!important;
  }

  .icon-arrow {
    color: ${colors.black};
    opacity: 0.5;
  }
`;

export const MenuContainer = lib.styled(Menu)`
  .MuiMenu-paper {
    width: 165px;
  }

  .input-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: sticky;
    top: 0;
    margin-top: -8px;
    background-color: white;
    z-index: 1;

    input {
      height: 25px;
      padding-left: 7px;
    }

    // &:hover {
    //   background-color: white;
    //   cursor: default;
    // }
  }

  .flag {
    max-width: 20px;
    margin-right: 5px;
    margin-bottom: 3px;
  }

  span {
    font-size: ${fonts.default}px;
  }
`;

export const ScrollableContainer = lib.styled.div`
  max-height: 200px;
  overflow-y: auto;
`;

export const Title = lib.styled.div`
  display: flex;
  width: 66px;
  height: 26px;
  background-color: ${colors.lightGray11};
  border-radius: 15px;
  text-align: center;
  justify-content: center;
  align-items: center;

  span {
    font-size: 10px;
    color: ${colors.black};
    opacity: 0.6;
  }
`;

export const Values = lib.styled.div`
  display: flex;
  width: 105px;
  height: 26px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  line-height: 10px;
`;

export const Row = lib.styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .flag {
    max-width: 18px;
    margin-top: 2px;
    margin-right: 5px;
    margin-bottom: 3px;
  }

  span {
    font-size: 14px;
    line-height: 1.3;
    color: ${colors.black};
    opacity: 0.6;
  }
`;
